import { render, staticRenderFns } from "./payment-column.vue?vue&type=template&id=58b46b56&scoped=true"
import script from "./payment-column.vue?vue&type=script&lang=js"
export * from "./payment-column.vue?vue&type=script&lang=js"
import style0 from "./payment-column.vue?vue&type=style&index=0&id=58b46b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b46b56",
  null
  
)

export default component.exports